module.exports = __webpack_public_path__ + "img/bn_n.761581fc.png";